'use client';

import type { ProductInformation, RecentProduct } from '@dealerportal/common';
import type { TokenValue } from 'libs/backend/src/lib/core/domain/valueObjects/TokenValue';
import { createContext, useContext } from 'react';

export interface ClientContextProps {
  tokens: TokenValue[];
  universalRetailerId: string | undefined;
  clientId: number | undefined;
  recaptcha: {
    Enabled: boolean;
    SiteKey?: string;
  };
  clientName: string | undefined;
  isMobileDevice: boolean;
  recentProducts: RecentProduct[];
  addRecentProduct: (product: ProductInformation) => void;
  disableOrderSample: boolean;
  useCiC: boolean;
  visualizerSettings?: {
    showVisualizer: boolean;
    apiKey?: string;
  };
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export const ClientContext = createContext<ClientContextProps>({
  tokens: [],
  universalRetailerId: undefined,
  clientId: undefined,
  recaptcha: { Enabled: false },
  isMobileDevice: false,
  clientName: undefined,
  recentProducts: [],
  addRecentProduct: () => {},
  disableOrderSample: false,
  useCiC: false,
});

/* eslint-disable @typescript-eslint/no-explicit-any */
export function useClientContext(): ClientContextProps {
  const ctx = useContext(ClientContext);

  return ctx;
}
